var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M17.503 4.2c-7.341 0-13.3 5.958-13.3 13.3 0 7.342 5.958 13.3 13.3 13.3 7.342 0 13.3-5.958 13.3-13.3 0-7.342-5.958-13.3-13.3-13.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.852 17.5 4.75 4.988 8.55-9.976"
  })));
};
export { SvgCheckCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzNSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjUwMzEgNC4yMDAwMUMxMC4xNjE1IDQuMjAwMDEgNC4yMDMxMiAxMC4xNTg0IDQuMjAzMTIgMTcuNUM0LjIwMzEyIDI0Ljg0MTYgMTAuMTYxNSAzMC44IDE3LjUwMzEgMzAuOEMyNC44NDQ3IDMwLjggMzAuODAzMSAyNC44NDE2IDMwLjgwMzEgMTcuNUMzMC44MDMxIDEwLjE1ODQgMjQuODQ0NyA0LjIwMDAxIDE3LjUwMzEgNC4yMDAwMVoiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0xMC44NTE2IDE3LjVMMTUuNjAxNiAyMi40ODc1TDI0LjE1MTYgMTIuNTEyNSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";